<div *ngIf="recipientInfo">
  <h2>Recipient Information</h2>
  <p>{{ recipientInfo.name }}</p>
  <p>{{ recipientInfo.address.line1 }}</p>
  <p>
    {{ recipientInfo.address.city }}, {{ recipientInfo.address.state }},
    {{ recipientInfo.address.zipcode }}
  </p>
  <p *ngIf="recipientInfo.contact.phone">
    Phone: {{ recipientInfo.contact.phone }}
  </p>
</div>
